import React, { Component } from "react"
import { Outlet } from "react-router-dom"
import { connect } from "react-redux"
import PropTypes from "prop-types"

import SearchHeader from "search-new/components/SearchBar/SearchHeader"
import { mobileBreakpoint } from "app/static/frontend/design-constants"
import { selectCurrentUniqueFlvId } from "app/static/frontend/search-new/selectors"

import { selectSearchPreloadDataLoaded } from "shared/search/selectors"

const mapStateToProps = (state, props) => ({
    searchPreloadDataLoaded: selectSearchPreloadDataLoaded(state, props),
    uniqueFlvId: selectCurrentUniqueFlvId(state, props),
})

export class UnconnectedSearch extends Component {
    static hideSearch() {
        const currScroll = $(".main").attr("data-currScroll")

        $(".main").removeClass("qs-active")

        document.body.scrollTop = currScroll

        $("body").removeClass("no-scroll")
    }

    // we need to disable the entire page scrolling when search shows.
    static showSearch() {
        $(".main").attr("data-currScroll", document.body.scrollTop).addClass("qs-active")

        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0

        window.innerWidth > mobileBreakpoint && $("body").addClass("no-scroll")
    }

    componentDidMount() {
        UnconnectedSearch.showSearch()
    }
    componentWillUnmount() {
        UnconnectedSearch.hideSearch()
    }

    render() {
        // it'll get the component from the router
        return (
            <div id="qs-results">
                <div id="advanced-search">
                    {this.props.searchPreloadDataLoaded && (
                        <SearchHeader currentPath={this.props.location.pathname} uniqueFlvId={this.props.uniqueFlvId} />
                    )}
                    <Outlet />
                </div>
            </div>
        )
    }
}

UnconnectedSearch.propTypes = {
    children: PropTypes.element,

    location: PropTypes.object,
    searchPreloadDataLoaded: PropTypes.bool,
    uniqueFlvId: PropTypes.string,
}

export default connect(mapStateToProps, null)(UnconnectedSearch)
